import request from '@axios'

export function createUser(data) {
  return request({
    url: '/user',
    method: 'post',
    data: data
  })
}

export function getUser(id) {
  return request({
    url: '/user',
    method: 'get',
    params: {id}
  })
}

export function editUser(data) {
  return request({
    url: '/user/edit',
    method: 'put',
    data: data
  })
}

export function changePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'post',
    data: data
  })
}
